import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { useState } from 'react';
import { trpc } from '@/lib/trpc';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { Layout } from './-components/layout';
import { PageSeo } from './-components/page-seo';
import { slugs } from './contact.meta';
import { ContactInfo } from './-components/contact/info';
import { ContactPanel, type Audience } from './-components/contact/panel';
import { ExpandGroup, EXPAND_STEP_ROOMY } from './-components/expand';

export const Route = createFileRoute('/new/contact')({
	loader: ({ context }) => {
		// Warms the partner-NGO logos in the left column. `prefetchQuery`, not `ensureQueryData` — see
		// the homepage loader for why a floating rejected promise here takes the server process down.
		context.queryClient.prefetchQuery(trpc.portal.getWorldcooGlobalStats.queryOptions());
	},
	component: Component,
});

function Component() {
	const { t } = useLingui();
	// Both owned here because both drive BOTH columns. The audience picked on the right decides which
	// logos the strip on the left shows; sending swaps the panel for its confirmation and sets the
	// mailbox in the address card drawing. Neither column can see the other's state.
	const [audience, setAudience] = useState<Audience | null>(null);
	const [sent, setSent] = useState(false);

	return (
		<Layout>
			<Header />
			<PageSeo
				slugs={slugs}
				title={t`Contact - Worldcoo`}
				description={t`If you'd like to incorporate Charity Rounding Up, if you're a social entity, or if you'd like some more information, please contact us.`}
			/>
			<ExpandGroup step={EXPAND_STEP_ROOMY} asChild>
				<section className="mx-auto grid max-w-[1440px] items-start gap-6 px-6 pt-4 pb-16 md:pb-24 lg:grid-cols-[793fr_559fr] xl:px-8">
					<ContactInfo audience={audience} sent={sent} />
					<ContactPanel audience={audience} onAudienceChange={setAudience} sent={sent} onSent={() => setSent(true)} />
				</section>
			</ExpandGroup>
			{/* `links`, not `form`: a second contact form directly under this one would be absurd. */}
			<Footer />
		</Layout>
	);
}
